module.exports = __webpack_public_path__ + "img/logo-white.2de6702f.svg";